<h1 *ngIf="movie" class="movie-title">{{ movie.title }}</h1>
